export const CONFIGURABLE_ACTIONS_OWNER  = 'Custom Actions';
export const CONFIGURABLE_ACTIONS_NAME  = 'External Sign In';
